module.exports = __webpack_public_path__ + "static/media/recharges.43f8cb1c.svg";